<template>
  <!--签章管理-->
  <div class="ent-sign">
    <h1 class="com-title com-ht"><i></i>我的印章</h1>
    <div class="box-wrap">
      <div class="temone" v-if="defalutChapter">
        <div class="t-box">
          <img
            class="y-img"
            :src="'data:image/jpeg;base64,' + this.defalutChapter.signName"
          />
        </div>
        <p title="系统图形章">系统图形章</p>
      </div>

      <div class="temone" v-for="(item, index) in chapterList" :key="index">
        <div class="t-box">
          <!-- 是默认签章-->
          <img
            v-if="item.defaultChapter && item.defaultChapter === 1"
            class="mr-label"
            src="/images/web/icon-default.png"
          />
          <!-- 签章-->
          <img class="y-img" :src="item.signUrl" :title="item.signName" />
          <div class="msk">
            <span
              class="setmr-btn"
              v-if="!(item.defaultChapter && item.defaultChapter === 1)"
              @click="setDefaultSeal(item.signId)"
              >设为默认
            </span>
            <span
              class="el-icon-edit-outline"
              style="margin-top:1px;"
              @click="openFileUploadDialog(item)"
              title="修改"
            ></span>
            <span
              class="el-icon-delete"
              @click="delChapter(item.signId)"
              title="删除"
            ></span>
          </div>
        </div>
        <p :title="`${item.signName}(ID:${item.signId})`">
          {{ `${item.signName}(ID:${item.signId})` }}
        </p>
        <div class="switch-style" v-if="userType">
          <span>打开后该印章可授权给成员&nbsp;</span>
          <switch-button
            v-model="item.corpSealId"
            :object="item"
            @confirmFn="allowToUse"
          ></switch-button>
        </div>
      </div>
      <el-popover placement="right" width="200" v-model="addVisible">
        <div class="popover-style">
          <el-button size="mini" @click="openFileUploadDialog"
            >本地上传</el-button
          >
          <el-button
            size="mini"
            @click="
              addVisible = !addVisible;
              onLineVise = !onLineVise;
            "
            >在线制作</el-button
          >
        </div>
        <div slot="reference" class="temone add">
          <span class="el-icon-plus"></span>
        </div>
      </el-popover>
      <!-- <div class="temone add" @click="openFileUploadDialog">
        <span class="el-icon-plus"></span>
      </div> -->
    </div>

    <!--上传 更新签章弹窗-->
    <el-dialog
      @closed="handleDialogClosed"
      title="上传签章"
      :visible.sync="isAddSign"
      :close-on-click-modal="false"
      width="550px"
      class="ent-dialog"
    >
      <el-form
        :model="chapterParam"
        :rules="signNameRules"
        ref="entForm"
        class="ent-form"
      >
        <el-form-item>
          <div class="upload-sign">
            <img v-if="chapterParam.signUrl" :src="chapterParam.signUrl" />
            <template v-else>
              <i class="el-icon-plus"></i>
              <label>点击上传签章图片</label>
            </template>
            <input type="file" accept="image/png" @change="handleInputChange" />
          </div>
        </el-form-item>
        <el-form-item prop="signName">
          <el-input maxLength="15" v-model="chapterParam.signName" placeholder="签章名称" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="text-left sign-tip">
          签章备注：
          <ol>
            <li>尺寸: 180 * 180px</li>
            <li>
              方法一：电脑使用PS，对签章抠图(去掉背景，存储为PNG格式)<br />
              方法二：<a target="_blank" href="http://www.aigei.com/bgremover"
                >透明处理链接</a
              >
            </li>
          </ol>
        </div>
        <p class="text-center btn">
          <el-button @click="queryUploadInfo" type="danger">保存</el-button>
        </p>
      </div>
    </el-dialog>
    <!--签章子系统权限弹窗-->
    <el-dialog
      title="签署配置"
      :visible.sync="dialogVisibleChild"
      :close-on-click-modal="false"
      width="560px"
      class="dialog-child"
    >
      <div class="child-list">
        <template
          v-if="chapterChildList.length"
          v-for="(item, index) in chapterChildList"
        >
          <div :key="index" class="text-center list-item">
            <el-checkbox v-model="item.ifUse">{{ item.sourceTag }}</el-checkbox>
          </div>
        </template>
      </div>
      <div slot="footer" class="text-center footer-btn">
        <el-button
          @click="queryChangeChildChapter"
          type="success"
          size="small"
          class="btn"
          >确定</el-button
        >
        <el-button
          @click="dialogVisibleChild = false"
          type="danger"
          size="small"
          class="btn"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <goto-auth :authDialog.sync="authDialog"></goto-auth>
    <!-- 在线制作印章弹窗 -->
    <!-- v-if="onLineVise" -->
    <sign-on-line
      :onLineVise="onLineVise"
      @viseControl="onLineVise = !onLineVise"
      @getChapterList="getChapterList"
    ></sign-on-line>
  </div>
</template>

<script>
import {
  fileOperShow,
  postFileTempUpload
} from "../../assets/js/http-serve/http-methods";
import EntSignController from "../../assets/js/http-serve/entSignController";
import { getFix } from "../../assets/js/lib/common";
import switchButton from "../../components/switch-button/index";
import signOnLine from "../../components/tpl-editor/signOnline.vue";

export default {
  data() {
    return {
      onLineVise: false, // 在线制作印章窗口
      addVisible: false, // 新增签章选择类型的弹窗
      defalutChapter: {},
      chapterList: [],
      // 上传章的参数
      chapterParam: {
        targetId: null,
        targetFix: null,
        signName: null,
        signId: null,
        signUrl: ""
      },
      signNameRules: {
        signName: [
          {
            min: 1,
            max: 50,
            message: "签章名称不能大于50个字符",
            trigger: "change"
          }
        ]
      },
      // 显示上传修改章的弹窗
      isAddSign: false,
      // 签章使用的子系统列表
      chapterChildList: [],
      chapterChaildParam: { signGives: [], signId: null },
      // 签章子系统弹窗显示
      dialogVisibleChild: false,
      loading: null,
      authDialog: false
    };
  },
  mounted() {
    this.getChapterList();
  },
  methods: {
    // 设置默认章
    setDefaultSeal(signId) {
      if (!signId) return false;
      EntSignController.setEntDefaultSeal(signId).then(() => {
        this.getChapterList();
      });
    },
    // 确认修改子系统的签章权限
    queryChangeChildChapter() {
      this.chapterChildList.forEach(t => {
        this.chapterChaildParam.signGives = [];
        if (t.ifUse) {
          this.chapterChaildParam.signGives.push({
            sourceTagId: t.sourceTagId,
            sourceTag: t.sourceTag
          });
        }
      });
      this.chapterChaildParam.signGives = JSON.stringify(
        this.chapterChaildParam.signGives
      );

      this.$confirm("此操作会清空子账户的签章，确定要继续？", "系统提示", {
        type: "info"
      })
        .then(() => {
          EntSignController.giveUpdate(this.chapterChaildParam)
            .then(data => {
              this.dialogVisibleChild = false;
              this.$message({ message: "签章配置成功", type: "success" });
            })
            .catch(err => {
              this.dialogVisibleChild = false;
              this.$message({ message: err.description, type: "warning" });
            });
        })
        .catch(() => {});
    },
    // 权限修改弹窗 获取签章子系统列表
    openChildGetChapChild(signId) {
      this.loadingStart();
      EntSignController.giveList(signId)
        .then(({ data }) => {
          this.loadingClose();
          this.chapterChaildParam.signId = signId;
          this.chapterChildList = data;
          this.dialogVisibleChild = true;
        })
        .catch(err => {
          this.loadingClose();
          this.$message({ message: err.description, type: "warning" });
        });
    },
    // 允许/禁止成员使用
    allowToUse(corpSealId, item) {
      if (!item.signId) return false;
      // item.corpSealId 大于0说明是用户是要禁止使用，反之就是允许
      return new Promise((resolve, reject) => {
        let { corpSealId, signId } = item;
        const isUse = corpSealId > 0 ? true : false;
        const confirmText = isUse
          ? "关闭之后将清除该印章已授权的成员和审批流程，是否继续?"
          : "开启成功，是否前往授权？";
        if (!isUse) {
          // 如果是允许使用，则先调用使用接口再弹窗
          this.loadingStart();
          EntSignController.allowMemberUse(signId)
            .then(async res => {
              if (!res.success) return;
              await this.getChapterList();
              this.$confirm(confirmText, "系统提示", {
                type: "warning"
              })
                .then(() => {
                  // 签章授权
                  // this.$router.push({
                  //   path: "/console/setting",
                  //   query: { activeName: "tab-seal" }
                  // });
                  this.$router.push({
                    path: "/console/template",
                    query: { activeName: "mianSign" }
                  });
                  resolve();
                })
                .catch(() => {
                  // 点击取消按钮
                  reject();
                });
              // 弹窗 end
            })
            .catch(err => {
              this.$message({
                message: err.description,
                type: "warning"
              });
            })
            .finally(() => {
              this.loadingClose();
            });
        } else {
          // 关闭
          this.$confirm(confirmText, "系统提示", {
            type: "warning"
          })
            .then(() => {
              // 禁止成员使用
              EntSignController.disableMemberUse(signId).then(res => {
                if (!res.success) return;
                this.getChapterList();
              });
              resolve();
            })
            .catch(() => {
              // 点击取消按钮
              reject();
            });
        } // if else end
      });
    },
    // 删除章
    delChapter(signId) {
      if (!signId) return;

      this.$confirm(
        "删除之后，该印章将彻底消失，授权的组织成员将无法使用该印章，已发起的合同不受影响，是否继续？",
        "系统提示",
        {
          type: "error"
        }
      )
        .then(() => {
          EntSignController.del(signId)
            .then(data => {
              this.$message({ message: "签章删除成功", type: "success" });
              this.getChapterList();
            })
            .catch(data => {
              this.$message({
                message: data.description || "签章保存失败",
                type: "warning"
              });
            });
        })
        .catch(() => {});
    },
    // 确认保存章
    queryUploadInfo() {
      if (!this.chapterParam.targetId && this.chapterParam.signId == null)
        return this.$message.error("请上传png格式的图片签章");
      this.$refs.entForm.validate(val => {
        if (val) {
          this.isAddSign = false;
          this.loadingStart();
          EntSignController.update(this.chapterParam)
            .then(data => {
              this.loadingClose();
              this.getChapterList();
              this.$message({ message: "签章保存成功", type: "success" });
            })
            .catch(err => {
              this.loadingClose();
              this.$confirm(err.description || "签章保存失败", "系统提示", {
                showCancelButton: false,
                confirmButtonText: "确定",
                type: "warning"
              }).then(() => {});
            });
        }
      });
    },
    // 上传章 input上传到临时文件api
    handleInputChange: function(e) {
      e = e.target;
      let param = { file: e.files[0], fileType: 1 };

      if (param.file.size > 5 * 1024 * 1024) {
        e.value = "";
        param = { file: "", fileType: 1 };

        return this.$confirm(`上传的签章文件不能超过5M`, "系统提示", {
          showCancelButton: false,
          confirmButtonText: "确定",
          type: "warning"
        })
          .then(() => {})
          .catch(() => {});
      }

      let { name, fix } = getFix(param.file.name);
      this.chapterParam.signUrl = window.URL.createObjectURL(param.file);
      this.chapterParam.targetFix = fix;
      this.chapterParam.signName = name;

      this.loadingStart();
      postFileTempUpload(param)
        .then(data => {
          this.chapterParam.targetId = data.targetId;
          e.value = "";
          this.loadingClose();
        })
        .catch(err => {
          this.loadingClose();

          e.value = "";
          this.$message(err.description || "上传文件失败");
        });
    },
    // 打开上传新的章或修改章的弹窗
    openFileUploadDialog(chapter = null) {
      if (this.$store.getters.authUser.identityAuth > -1) {
        this.chapterParam = {
          targetId: null,
          targetFix: null,
          signName: "",
          signId: null,
          signUrl: ""
        };
        if (chapter) {
          this.chapterParam.signId = chapter.signId;
          this.chapterParam.signName = chapter.signName;
          this.chapterParam.signUrl = chapter.signUrl;
        }
        this.isAddSign = true;
        this.addVisible = !this.addVisible;
      } else {
        this.authDialog = true;
      }
    },
    // 弹窗关闭
    handleDialogClosed() {
      this.chapterParam = {
        targetId: null,
        targetFix: null,
        signName: "",
        signId: null,
        signUrl: ""
      };
    },
    // 获取章列表
    getChapterList() {
      this.loadingStart();
      EntSignController.getAll()
        .then(data => {
          let list = data.data;

          if (!data.data || !data.data.length) {
            this.chapterList = [];
          }
          this.defalutChapter = data.data[0];
          list.shift();
          list.forEach(t => {
            t.signUrl = fileOperShow(t.signUrl);
          });
          list.forEach((t, i) => {
            if (t.defaultChapter && t.defaultChapter === 1) {
              var defSeal = list.splice(i, 1);
              list.unshift(t);
            }
          });
          this.chapterList = list;
          this.loadingClose();
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    loadingStart() {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true
        // text: '正在拼命加载中',
        // spinner: 'el-icon-loading',
        // background: 'rgba(0, 0, 0, .5)'
      });
    },
    loadingClose() {
      if (this.loading) this.loading.close();
    }
  },
  computed: {
    // 是否企业用户 0：个人，1：企业
    userType() {
      let userInfo = this.$store.getters.currentAuthUser,
        allUser = this.$store.getters.allAuthUser;
      return userInfo.userType == 1 && allUser.corpCreateFlag == 1
        ? true
        : false;
    }
  },
  components: {
    switchButton,
    signOnLine
  },
  name: "index"
};
</script>

<style lang="less" scoped>
.ent-sign {
  border: 1px solid #f0f0f0;
  height: calc(100vh - 280px);
  overflow-y: auto;
  .ent-dialog {
    .sign-tip {
      padding: 20px;
      color: #a1a1a1;
      line-height: 150%;
      ol {
        list-style-position: outside;
        margin-left: 30px;
      }
    }
    .upload-sign {
      position: relative;
      display: block;
      box-sizing: content-box;
      padding: 10px;
      border: 1px dashed #b4b4b4;
      text-align: center;
      color: #a1a1a1;
      overflow: hidden;
      cursor: pointer;

      i {
        vertical-align: top;
        color: #333333;
        font-size: 64px;
        font-weight: 600;
        line-height: 90px;
        height: 90px;
      }
      label {
        display: block;
        font-weight: 600;
        font-size: 18px;
        line-height: 1;
        margin-bottom: 5px;
      }
      img {
        max-height: 120px;
        vertical-align: middle;
      }
      input {
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 400px;
        top: -20px;
        left: 0;
        opacity: 0;
        cursor: pointer;
      }
    }
    .ent-form {
      width: 80%;
      margin: 0 auto;
    }
  }

  .box {
    padding: 20px;

    .card {
      width: 250px;
      position: relative;
      margin: 0 auto;

      .seal-type {
        display: inline-block;
        box-sizing: border-box;
        position: absolute;
        top: 10px;
        left: 20px;
        cursor: pointer;
      }

      .add-sign {
        height: 140px;
        line-height: 140px;
        text-align: center;
        cursor: pointer;
        i {
          font-size: 64px;
          vertical-align: middle;
        }
      }

      .bottom {
        padding: 10px 8px;
        background-color: #f8f8f8;
        border-top: 0;
        color: #333;
        font-size: 12px;
        text-align: left;

        .add {
          cursor: pointer;
        }

        .action span {
          margin-left: 5px;
          cursor: pointer;
        }
      }

      .img-box {
        text-align: center;
        height: 140px;
        line-height: 140px;
        img {
          max-height: 90px;
          vertical-align: middle;
        }
      }

      .del-sign {
        display: none;
        position: absolute;
        color: #cccccc;
        right: 5px;
        top: 5px;
        font-size: 18px;
        cursor: pointer;
      }
    }

    .card:hover {
      .del-sign,
      .del-sign:hover {
        display: inline-block;
      }
    }

    p.sign-name {
      width: 250px;
      line-height: 20px;
      height: 20px;
      margin: 5px 0;
    }
  }

  h4 {
    margin: 0;
    padding: 12px;
    background-color: #f8f8f8;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

.box-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-left: -20px;
  margin-top: -15px;
  padding: 15px;
  &:last-child {
    margin-bottom: 130px;
  }
  .temone {
    margin-left: 20px;
    margin-top: 15px;
    width: 175px;
    text-align: center;
    align-items: center;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    height: 167px;
    &.add {
      cursor: pointer;
      height: 167px;
      line-height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
      }
    }
    p {
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
      width: 100%;
      font-family: Source Han Sans SC;
      box-sizing: border-box;
      height: 35px;
      line-height: 35px;
      background: rgba(239, 239, 239, 1);
      color: rgba(41, 2, 2, 0.65);
    }
    .t-box {
      position: relative;
      width: 100%;
      height: 105px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      &:hover {
        .msk {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
      }
      .y-img {
        /*width: 106px;*/
        /*min-height: 100px;*/
        width: 96px;
        height: auto;
        display: block;
        margin: 8px auto 7px auto;
      }
      .msk {
        transition: all ease 0.2s;
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        padding: 8px 8px;
        box-sizing: border-box;
        z-index: 10;
        span {
          cursor: pointer;
          float: right;
          color: #ffffff;
          font-size: 20px;
          margin-left: 10px;
          &:hover {
            color: rgba(236, 28, 28, 1);
          }
        }
        .setmr-btn {
          float: left;
          font-size: 14px;
          margin-left: 0;
        }
      }
      .mr-label {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 12px;
        color: rgba(236, 28, 28, 1);
        z-index: 5;
      }
    }
    .el-icon-plus {
      cursor: pointer;
      color: #c9bfbf;
      font-size: 80px;
    }
    .switch-style {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #290202a6;
      font-size: 12px;
      margin-top: 3px;
    }
  }
}
.popover-style {
  height: 100px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /deep/ .el-button + .el-button {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/entSign.vue